var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-row',{staticClass:"content-wrapper",attrs:{"type":"flex","justify":"center","align":"middle"}},[_c('el-col',{staticClass:"content-wrapper__container",attrs:{"span":_vm.span}},[_c('ContentHeader',{attrs:{"title":_vm.title}}),_c('div',{staticClass:"content-wrapper__body",style:(_vm.bodyStyle)},[_vm._t("default")],2)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }